const DOMAIN = process.env.REACT_APP_API_URL || "http://localhost:8000/";
const ANON_FRONTEND = process.env.REACT_APP_ANON_FRONTEND || "https://try.sherpah.com.au";

export { DOMAIN, ANON_FRONTEND };
